import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSecurity(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M11.1 15h1.8c.15 0 .28-.063.387-.188a.452.452 0 0 0 .113-.412l-.475-2.625a1.89 1.89 0 0 0 .787-.725c.192-.317.288-.667.288-1.05 0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 12 8c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 10 10c0 .383.096.733.287 1.05.192.317.455.558.788.725L10.6 14.4a.452.452 0 0 0 .113.412.497.497 0 0 0 .387.188Zm.9 6.9a1.976 1.976 0 0 1-.625-.1c-2.25-.75-4.042-2.137-5.375-4.163-1.333-2.024-2-4.204-2-6.537V6.375c0-.417.12-.792.362-1.125.242-.333.555-.575.938-.725l6-2.25a2.07 2.07 0 0 1 .7-.125c.233 0 .467.042.7.125l6 2.25c.383.15.696.392.938.725.241.333.362.708.362 1.125V11.1c0 2.333-.667 4.513-2 6.537-1.333 2.026-3.125 3.413-5.375 4.163a1.959 1.959 0 0 1-.625.1Zm0-2c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5V6.375l-6-2.25-6 2.25V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3Z"
      />
    </BaseIcon>
  );
}
